﻿import { useParams, useNavigate } from "react-router-dom";

import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";
import CustomInputTextArea from "@/components/desktop/form/input/input-textarea/CustomInputTextArea";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";

import { base_object } from "../oatype.constants";
import { useOATypeForm } from "@/hooks/maintainers/OA/OA-type/useOATypeForm";

const OATypeForm = ({ filters }) => {
	const navigate = useNavigate();
	const { option, element_id } = useParams();

	const onClose = () => {
		setFormState({ ...base_object });
		setFormErrors({});
		navigate("/configuracion/tipo_orden_aplicacion");
	};

	const {
		isOpen,
		modalTitle,
		isLoadingLookups,
		isLoadingSave,
		isLoadingElement,
		isFetchingElement,
		orderApplicationTypeOptions,
		estateParentOptions,
		filteredEstateOptions,
		formState,
		setFormState,
		formErrors,
		setFormErrors,
		handleEstateParentsChange,
		handleSubmit,
	} = useOATypeForm({
		option,
		filters,
		elementId: element_id,
		baseObject: base_object,
		onClose,
	});

	if (!isOpen) return null;

	const hasSelectedParents = Array.isArray(formState.estate_parent_id) && formState.estate_parent_id.length > 0;

	const isLoading = isLoadingLookups || isLoadingSave || isLoadingElement || isFetchingElement;

	return (
		<CustomModalForm open={isOpen} onClose={onClose} title={modalTitle} size="sm" asForm onSubmit={handleSubmit} isLoading={isLoading}>
			{isLoading ? (
				<CustomFetching center size="lg" />
			) : (
				<>
					<CustomInputSelect
						label="Tipo de OA"
						name="application_order_type_id"
						options={orderApplicationTypeOptions}
						value={formState.application_order_type_id}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, application_order_type_id: value }));
							setFormErrors((prev) => ({ ...prev, application_order_type_id: undefined }));
						}}
						placeholder="Seleccionar tipo de OA"
						required
						col={12}
						error={formErrors.application_order_type_id}
					/>

					<CustomInputSelect
						label="Campos"
						name="estate_parent_id"
						isMulti
						options={estateParentOptions}
						value={formState.estate_parent_id || []}
						onChange={(value) => {
							handleEstateParentsChange(value);
						}}
						placeholder="Seleccionar Campos"
						required
						col={12}
						error={formErrors.estate_parent_id}
					/>

					<CustomInputSelect
						label="Bodegas"
						name="estate_id"
						isMulti
						options={filteredEstateOptions}
						value={formState.estate_id || []}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, estate_id: value || [] }));
							setFormErrors((prev) => ({ ...prev, estate_id: undefined }));
						}}
						placeholder={hasSelectedParents ? "Seleccionar Bodegas" : "Seleccione primero Campo(s)"}
						required
						col={12}
						error={formErrors.estate_id}
					/>

					<CustomInputText
						label="Nombre"
						name="name"
						value={formState.name}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, name: value }));
							setFormErrors((prev) => ({ ...prev, name: undefined }));
						}}
						placeholder="Ingrese el nombre"
						required
						col={12}
						error={formErrors.name}
					/>

					<CustomInputTextArea
						label="Descripción"
						name="description"
						value={formState.description}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, description: value }));
							setFormErrors((prev) => ({ ...prev, description: undefined }));
						}}
						placeholder="Ingrese la descripción"
						col={12}
						error={formErrors.description}
					/>
				</>
			)}
		</CustomModalForm>
	);
};

export default OATypeForm;
